var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { DateTime, Interval } from "luxon";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import { Dropdown } from "semantic-ui-react";
/**
 * Renders two Menu.Items for a date range preset dropdown and start/end date pickers.
 *
 * Because even the nth attempt in JS to build chrono abstractions still sucks, there's no date-without-time type,
 * so timestamps at local timezone midnight are what we have to deal with.
 * Also, the datepicker component uses Moment types, not Luxon, but Luxon has an Interval type, which is tidy for
 * our usecase. So, we use a Luxon Interval of two local DateTimes and convert back and forth between Luxon and
 * Moment as needed for display and input.
 *
 * Fortunately, if we blithely ignore the timezone and hour-minute-second components, it all works out: the
 * datepicker produces and consumes "dates" (local time midnight), and we format as y-m-d when populating request
 * params, so they appear as proper dates to the server.
 */
var DateRangePicker = /** @class */ (function (_super) {
    __extends(DateRangePicker, _super);
    function DateRangePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.onIntervalPresetChange = function (event, data) {
            var num = data.value;
            if (typeof (num) !== 'number') {
                throw new Error("Invalid value: " + num);
            }
            _this.applyPreset(num);
        };
        _this.applyPreset = function (days) {
            var end = nowDate();
            var start = end.minus({
                // subtracting n days would create an n+1 day range
                days: days - 1
            });
            _this.props.onIntervalChange(Interval.fromDateTimes(start, end));
        };
        _this.onIntervalStartChange = function (date) {
            if (date == null) {
                _this.setState({
                    interval: undefined
                });
            }
            else {
                var start = DateTime.fromJSDate(date);
                var end = _this.props.interval && _this.props.interval.end
                    ? _this.props.interval.end
                    : nowDate();
                // end must be >= start
                if (end.diff(start).valueOf() < 0) {
                    end = start;
                }
                _this.props.onIntervalChange(Interval.fromDateTimes(start, end));
            }
        };
        _this.onIntervalEndChange = function (date) {
            if (date == null) {
                _this.setState({
                    interval: undefined
                });
            }
            else {
                var end = DateTime.fromJSDate(date);
                var start = _this.props.interval && _this.props.interval.start
                    ? _this.props.interval.start
                    : nowDate();
                // end must be >= start
                if (end.diff(start).valueOf() < 0) {
                    start = end;
                }
                _this.props.onIntervalChange(Interval.fromDateTimes(start, end));
            }
        };
        if (props.defaultDayRange && props.dayRangeOptions.indexOf(props.defaultDayRange) < 0) {
            throw Error("Default day range must be one of the options");
        }
        return _this;
    }
    DateRangePicker.prototype.render = function () {
        var startForDatePicker = this.props.interval
            ? this.props.interval.start.toJSDate()
            : null;
        var endForDatePicker = this.props.interval
            ? this.props.interval.end.toJSDate()
            : null;
        return React.createElement(React.Fragment, null,
            this.props.includePresets && React.createElement(Dropdown, { onChange: this.onIntervalPresetChange, options: this.props.dayRangeOptions.map(function (range) { return ({
                    text: "Last " + range + " days",
                    value: range
                }); }), search: true, style: { paddingRight: '1rem' }, text: 'Presets' }),
            React.createElement(DatePicker, { selected: startForDatePicker, startDate: startForDatePicker ? startForDatePicker : undefined, endDate: endForDatePicker ? endForDatePicker : undefined, onChange: this.onIntervalStartChange, placeholderText: 'Select date' }),
            "\u00A0to\u00A0",
            React.createElement(DatePicker, { selected: endForDatePicker, startDate: startForDatePicker ? startForDatePicker : undefined, endDate: endForDatePicker ? endForDatePicker : undefined, onChange: this.onIntervalEndChange, placeholderText: 'Select date' }),
            this.props.interval &&
                React.createElement(React.Fragment, null,
                    "\u00A0(",
                    this.props.interval.length('days') + 1,
                    " days)"));
    };
    DateRangePicker.prototype.componentDidMount = function () {
        if (this.props.defaultDayRange !== undefined && this.props.interval === undefined) {
            this.applyPreset(this.props.defaultDayRange);
        }
    };
    return DateRangePicker;
}(React.PureComponent));
export default DateRangePicker;
/**
 * If local date is 03-12 and UTC date is 03-13, the returned instant will be at 03-13, local time, midnight.
 *
 * This odd behavior is to minimize the pain of shifting between moment (needed by the actual UI component) and luxon
 * (needed by my desire for a slightly less bad JS date/time library).
 *
 * @return a Luxon DateTime set to what the current date is in UTC, except at local time midnight.
 */
var nowDate = function () {
    var now = DateTime.utc();
    return DateTime.local(now.year, now.month, now.day);
};
//# sourceMappingURL=DateRangePicker.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/DateRangePicker.js
// module id = 212
// module chunks = 0